import api, { fetchAllPages } from "./client";

export const catalogoApi = {
  getServices: (params = {}) => fetchAllPages("/servicios/", params),
  getProducts: (params = {}) => fetchAllPages("/productos/", params),
  createService: (data) => api.post("/servicios/", data),
  updateService: (id, data) => api.patch(`/servicios/${id}/`, data),
  createProduct: (data) => api.post("/productos/", data),
  updateProduct: (id, data) => api.patch(`/productos/${id}/`, data),
};



